<template>
	<div class="survey-translations">
		<div class="d-flex justify-content-between align-items-center mb-3">
			<div>
				<h5 class="header-case mb-0">Translating: {{ survey.title }}</h5>
			</div>
	        <div>
	            <select v-model="activeLanguage" class="form-control"
	            	@change="generateSurveyTranslation(survey.id, activeLanguage)">
	                <option :value="null" selected disabled hidden>Select a language</option>
	                <option :value="language.id" v-for="language in languages">
	                    {{language.name}}
	                </option>
	            </select>
	        </div>
	    </div>
	    <div class="trasnlation-settings" v-if="activeLanguage && translations">
		    <div class="accordion mb-3" id="translations-accordion">
		    	<div class="card accordion-card">
			        <div class="card-header" id="headingOne">
			            <a href="#" data-toggle="collapse" @click="fieldsClicked = false" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
			              <span class="header-case readable-text"> Basic Settings</span>
			            </a>
			        </div>
			        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#translations-accordion">
	          			<div class="card-body">
	          				<p class="readable-text">First of all, edit basic settings such as the title & the description of the survey</p>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <th>Section</th>
                                    <th>Original</th>
                                    <th>Translation</th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="translation in translations.generalTranslations">
                                        <td>
                                            <div class="pr-2">{{ labelizeGeneral(translation.type) }}</div>
                                        </td>
                                        <td>
                                            <div class="translation-string pr-3" v-if="hasHtml(translation.type)">
                                                <div class="mw-100" v-html="translation.original"></div>
                                            </div>
                                            <div class="translation-string pr-3" v-else>
                                                {{ translation.original }}
                                            </div>
                                        </td>
                                        <td class="pb-2 edit-translation">
                                            <div v-if="hasHtml(translation.type)">
                                                <ckeditor :editor="editor" :config="editorConfig"
                                                          v-model="translation.translation"
                                                          @ready="onReady"></ckeditor>
                                            </div>
                                            <div v-else>
                                                <textarea class="form-control" v-model="translation.translation"></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
	      				</div>
	  				</div>
		        </div>

		        <div class="card accordion-card">
			        <div class="card-header" id="headingOne">
			            <a href="#" data-toggle="collapse" @click="fieldsClicked = true" class="d-flex justify-content-between align-items-center" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
			              <span class="header-case readable-text"> Fields</span>
			              <button class="btn btn-primary" v-show="! fieldsClicked">Next step</button>
			            </a>
			        </div>
			        <div id="collapseTwo" class="collapse" aria-labelledby="headingOne" data-parent="#translations-accordion">
	          			<div class="card-body">
	          				<p class="readable-text">Now, you can translate the survey fields as well as their options</p>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <th>Section</th>
                                    <th>Original</th>
                                    <th>Translation</th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="translation in translations.fieldTranslations">
                                        <td>
                                            <div class="pr-2">{{ labelizeGeneral(translation.type) }}</div>
                                        </td>
                                        <td>
                                            <div class="translation-string pr-3" v-if="hasHtml(translation.type)">
                                                <div class="mw-100" v-html="translation.original"></div>
                                            </div>
                                            <div class="translation-string pr-3" v-else>
                                                {{ translation.original }}
                                            </div>
                                        </td>
                                        <td class="pb-2 edit-translation">
                                            <div v-if="hasHtml(translation.type)">
                                                <ckeditor :editor="editor" :config="editorConfig"
                                                          v-model="translation.translation"
                                                          @ready="onReady"></ckeditor>
                                            </div>
                                            <div v-else>
                                                <textarea class="form-control" v-model="translation.translation"></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

					        <button class="btn my-3 btn-primary pull-right" :disabled="!fieldsClicked"
					        	@click="updateTranslation(survey.id, activeLanguage, translations)">
				                Save translation
				            </button>
	      				</div>
	  				</div>
		        </div>
		    </div>
	    </div>
	    <div v-else>
	    	<p class="thin-title text-center">Please select a lanuage to translate your survey</p>
	    </div>
	</div>
</template>

<script>
import SurveysService from '../../services/surveys-service'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
	props: ['survey'],
	components: {
		ckeditor: CKEditor.component
	},
	data() {
		return {
			editor: ClassicEditor,
            editorConfig: {
                removePlugins: ['Autoformat', 'ImageUpload', 'EasyImage', 'MediaEmbed', 'Highlight'],
                allowedContent: true
            },
			languages: [],
            translations: null,
            activeLanguage: null,
            fieldsClicked: false
		}
	},
	mounted() {
        this.$parent.$on('resetTranslationState', () => {
            this.activeLanguage = null
        });
		this.initiateTranslate()
	},
	methods: {
		onReady( editor )  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            )
        },
		hasHtml(type) {
			return ['emailBody'].includes(type)
		},
		async initiateTranslate() {
            this.activeLanguage = null

            const languages = await SurveysService.languages.get()
            this.languages = languages.data
        },
        async generateSurveyTranslation(surveyId, languageId) {
            const translations = await SurveysService.translations.generate(surveyId, languageId)

            this.translations = translations.data
        },
        getLangById(id) {
        	let lang = this.languages.filter(element => {
        		return element.id == id
        	})

        	if (lang.length == 1) {
        		return lang[0]
        	} else {
        		return null
        	}
        },
        async updateTranslation(surveyId, languageId, translations) {
            const generalTranslationsArray = []

            Object.keys(translations.generalTranslations).forEach(key => {
                generalTranslationsArray.push(translations.generalTranslations[key])
            })

            const finalTranslationsArray = generalTranslationsArray.concat(translations.fieldTranslations)
            const updated = await SurveysService.translations.update(surveyId, languageId, finalTranslationsArray)

            let lang = this.getLangById(languageId)

            if (updated && updated.data === true) {
            	let langName = lang ? lang.name : ''
            	swal('Success!', 'We have successfully saved the translations for ' + langName + '.')
            }

        }
	}
}
</script>NN
